import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SevenSegment from "@src/components/SevenSegment.vue";
import { computed, reactive, ref, watch } from "vue";
import { getFormattedTime } from "@src/helpers/timer";


export default /*#__PURE__*/_defineComponent({
  __name: 'Timer',
  props: {
  seconds: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    default: 80,
  },
  segmentSize: {
    type: Number,
    default: 7,
  },
  top: {
    type: Number,
    required: true,
  },
  left: {
    type: Number,
    required: true,
  },
  gap: {
    type: Number,
    default: 8,
  },
},
  setup(__props) {

const props = __props;



const digitWidth = props.height * 0.625;
const digitHeight = props.height;

const p1Active = ref(false);
const p2Active = ref(false);

let prevValue = 0;

watch(
  () => props.seconds,
  (value) => {
    const intVal = Math.floor(value);
    if (intVal != prevValue) {
      if (intVal < 60) {
        p1Active.value = false;
        p2Active.value = !p2Active.value;
      } else {
        p1Active.value = !p1Active.value;
        p2Active.value = p1Active.value;
      }
      prevValue = intVal;
    }
  },
);

const wrapperStyle = computed(() => {
  return {
    top: props.top + "px",
    left: props.left + "px",
    gap: props.gap + "px",
  };
});

const dividerStyle = computed(() => {
  return {
    height: props.height + "px",
  };
});

const diodeStyle = computed(() => {
  return {
    width: props.segmentSize * 2 + "px",
    height: props.segmentSize * 2 + "px",
  };
});

const characters = computed(() => {
  return getFormattedTime(props.seconds).split("");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "seven-segment-timer",
    style: _normalizeStyle(wrapperStyle.value)
  }, [
    _createVNode(SevenSegment, {
      class: "digit",
      "segment-size": __props.segmentSize,
      padding: __props.segmentSize,
      height: _unref(digitHeight),
      width: digitWidth,
      character: characters.value[0]
    }, null, 8 /* PROPS */, ["segment-size", "padding", "height", "character"]),
    _createVNode(SevenSegment, {
      class: "digit",
      "segment-size": __props.segmentSize,
      padding: __props.segmentSize,
      height: _unref(digitHeight),
      width: digitWidth,
      character: characters.value[1]
    }, null, 8 /* PROPS */, ["segment-size", "padding", "height", "character"]),
    _createElementVNode("div", {
      class: "divider",
      style: _normalizeStyle(dividerStyle.value)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["diode", { active: p1Active.value }]),
        style: _normalizeStyle(diodeStyle.value)
      }, null, 6 /* CLASS, STYLE */),
      _createElementVNode("div", {
        class: _normalizeClass(["diode", { active: p2Active.value }]),
        style: _normalizeStyle(diodeStyle.value)
      }, null, 6 /* CLASS, STYLE */)
    ], 4 /* STYLE */),
    _createVNode(SevenSegment, {
      class: "digit",
      "segment-size": __props.segmentSize,
      padding: __props.segmentSize,
      height: _unref(digitHeight),
      width: digitWidth,
      character: characters.value[2]
    }, null, 8 /* PROPS */, ["segment-size", "padding", "height", "character"]),
    _createVNode(SevenSegment, {
      class: "digit",
      "segment-size": __props.segmentSize,
      padding: __props.segmentSize,
      height: _unref(digitHeight),
      width: digitWidth,
      character: characters.value[3]
    }, null, 8 /* PROPS */, ["segment-size", "padding", "height", "character"])
  ], 4 /* STYLE */))
}
}

})